export default __webpack_public_path__ + "images/8U.33e254e.png";